import React from 'react';
import { useAuth } from '../context/AuthContext';
import { User, Building2, Calendar, Shield } from 'lucide-react';

const SettingsPage = () => {
  const { provider } = useAuth();

  return (
    <div data-testid="settings-page" className="animate-fade-in max-w-2xl">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-foreground">Settings</h1>
        <p className="text-muted-foreground">Account information and preferences</p>
      </div>

      {/* Account Info */}
      <div className="dashboard-card mb-6">
        <h2 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
          <User className="w-5 h-5" />
          Account Information
        </h2>
        
        <div className="space-y-4">
          <div className="flex items-center gap-4 p-4 bg-secondary/30 rounded-lg">
            <div className="w-12 h-12 bg-primary/20 rounded-full flex items-center justify-center">
              <Building2 className="w-6 h-6 text-primary" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Company Name</p>
              <p className="font-medium text-foreground">{provider?.company_name}</p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="p-4 bg-secondary/30 rounded-lg">
              <p className="text-sm text-muted-foreground mb-1">Email</p>
              <p className="font-medium text-foreground">{provider?.email}</p>
            </div>
            <div className="p-4 bg-secondary/30 rounded-lg">
              <p className="text-sm text-muted-foreground mb-1">Account Created</p>
              <p className="font-medium text-foreground">
                {provider?.created_at ? new Date(provider.created_at).toLocaleDateString() : 'N/A'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* API Info */}
      <div className="dashboard-card">
        <h2 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
          <Shield className="w-5 h-5" />
          API Information
        </h2>
        
        <div className="bg-secondary/30 rounded-lg p-4">
          <p className="text-sm text-muted-foreground mb-2">Device Authentication Endpoint</p>
          <code className="block bg-background p-3 rounded font-mono text-sm text-green-400 break-all">
            POST /api/device/auth
          </code>
          <p className="text-xs text-muted-foreground mt-2">
            Mobile apps use this endpoint with the 4-digit access code to retrieve MAC address and portal URL
          </p>
        </div>

        <div className="mt-4 p-4 bg-amber-500/10 border border-amber-500/30 rounded-lg">
          <p className="text-sm text-amber-400">
            <strong>Request Body:</strong>
          </p>
          <code className="block bg-background p-3 rounded font-mono text-xs text-foreground mt-2">
            {`{ "access_code": "XXXX" }`}
          </code>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
